module.exports = __webpack_public_path__ + "static/media/six.dbfd8b25.jpeg";